export const PERMISSION_BENUTZER_BEARBEITEN = "benutzer:bearbeiten";
export const PERMISSION_BENUTZER_HINZUFUEGEN = "benutzer:hinzufuegen";
export const PERMISSION_BENUTZER_LESEN = "benutzer:lesen";
export const PERMISSION_BENUTZER_LISTE = "benutzer:liste";
